import { Outside } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface ISelectDropdownContentLayoutProps {
  onClose(): void;
  children: React.ReactNode;
}

export function SelectDropdown({ children, onClose }: ISelectDropdownContentLayoutProps) {
  return (
    <Outside onOutside={onClose} active>
      <div className={styles['dropdown']}>{children}</div>
    </Outside>
  );
}
